<template>
    <v-card-text>
        <v-container fluid>
            <v-row dense>
                <v-col cols="12" sm="12">
                    <v-row dense align="center" justify="center">
                        <v-col cols="12" :sm="sm" v-for="(v,k) in listSeguros" :key="k">
                            <v-tooltip bottom width="40%">
                                <template v-slot:activator="{ on }">
                                    <v-img :src="v.foto"
                                        contain height="300" max-height="300" v-on="on" @click="next(v)">
                                    </v-img>
                                </template>
                                <span v-html="`Seguro de ${v.seguro}`"></span>
                            </v-tooltip>
                        </v-col>
                    </v-row>

                    <v-row dense class="mt-3 mb-3" align="center" justify="center">
                        <v-col cols="12" class="text-center">
                            <v-icon color="secundary" class="btnNext" @click="next">arrow_forward</v-icon>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
    export default {
        name: 'windowSegurosClienteComponent',
        inject:['setData','setStep'],
        props:{
            listSeguros:{
                type: Array,
                default: () => []
            },
            idSeguro:{
                type:Number,
                default:0
            }
        },
        watch:{
            idSeguro(val){
                this.setData('obSearch',{idSeguro:val});
            }
        },
        computed:{
            sm(){
                var n = _.size(this.listSeguros);
                var sm = 3;
                
                if(n > 1 && n < 3 )
                    sm = 6;
                else if(n > 2 && n < 5 )
                    sm = 4;
                else if(n > 4 && n < 7 )
                    sm = 3;

                return sm;
            }
        },
        methods:{
            next(v){
                this.setData('obSearch',{idSeguro:v.idSeguro});
                this.setStep(2);
            }
        }
    }
</script>